const fontSizeChangers = document.querySelectorAll('.font-size-changer')

const currentFontSize = localStorage.getItem('fontSize')

const setFontSize = size => {
	switch (size) {
		case 'small':
			document.documentElement.style.fontSize = '.9rem'
			break
		case 'normal':
			document.documentElement.style.fontSize = '1rem'
			break
		case 'large':
			document.documentElement.style.fontSize = '1.1rem'
			break
		default:
			document.documentElement.style.fontSize = '1rem'
	}
	localStorage.setItem('fontSize', size)
}

fontSizeChangers.forEach(changer => {
	changer.addEventListener('click', e => {
		setFontSize(changer.dataset.size)
	})
})
document.onload = setFontSize(currentFontSize)
